import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypeGetShippingLabelsParams, TypeGetShippingLabelsResponse } from '~/types/delivery-agency.types';

const useGetShippingLabels = () => {
  const { runAsync } = useAsyncHandler();

  const getShippingLabels = useAPI<TypeGetShippingLabelsParams, TypeGetShippingLabelsResponse>({
    endpoint: API_ENDPOINT.DELIVERY_AGENCY.GET_SHIPPING_LABELS,
    method: 'get',
  });

  const requestShippingLabels = async (
    params: TypeGetShippingLabelsParams,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: (data: TypeGetShippingLabelsResponse) => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) => {
    runAsync(() => getShippingLabels({ params }), {
      onSuccess: (data) => onSuccess?.(data),
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { requestShippingLabels };
};

export default useGetShippingLabels;
